import { apiGet } from '../../../shared/api-client/index.js';

export type OperationsWindow = '1h' | '24h' | '7d';
export type PublicDeliveryOutcome =
  | 'subscription_disabled'
  | 'authority_unavailable'
  | 'provider_retryable'
  | 'provider_recipient_unavailable'
  | 'privacy_revoked'
  | 'other';
export interface TelegramOperations {
  generatedAt: string;
  window: OperationsWindow;
  connections: Array<{
    ref: string | null;
    status: string;
    stateVersion: number;
    activatedAt: string | null;
  }>;
  flags: Record<
    | 'beta'
    | 'inboundWorker'
    | 'deliveryWorker'
    | 'groupExtraction'
    | 'approvalResults'
    | 'dailyDigest',
    boolean
  >;
  ingress: {
    total: number;
    statuses: Array<{ status: string; count: number }>;
    dueDepth: number;
    oldestDueAgeSeconds: number | null;
    duplicateRatio: number | null;
    p95ProcessingMs: number | null;
  };
  delivery: {
    total: number;
    statuses: Array<{ status: string; count: number }>;
    dueDepth: number;
    oldestDueAgeSeconds: number | null;
    successRate: number | null;
    ambiguousCount: number;
    p95LatencyMs: number | null;
  };
  candidates: Array<{ type: string; status: string; count: number }>;
  approvals: Array<{ status: string; count: number }>;
  subscriptions: Array<{ type: string; status: string; count: number }>;
  alerts: Array<{ code: string; severity: 'warning' | 'critical' }>;
  recent: Array<{
    ref: string;
    kind: string;
    status: string;
    attempt: number;
    ageSeconds: number | null;
    durationMs: number | null;
    outcomeCode: PublicDeliveryOutcome | null;
  }>;
}

export const telegramOperationsQueryKey = (workspaceId: string, window: OperationsWindow) =>
  ['telegram-operations', workspaceId, window] as const;
export const getTelegramOperations = (window: OperationsWindow): Promise<TelegramOperations> =>
  apiGet(`/integrations/telegram/operations?window=${window}`);
